import React from "react";
import { useTranslation } from "react-i18next";
import { ApiRegistration, ApiTask } from "src/api/types";
import Avatar from "src/components/Avatar";
import ConnectUserButton from "src/components/ConnectUserButton";
import Link from "src/components/Link";
import Stars from "src/components/Stars";
import useAuth from "src/hooks/selectors/useAuth";
import useBackUrl from "src/hooks/useBackUrl";
import { generateTextColor } from "src/lib/colors";

interface RegistrationHeadProps {
	registration: ApiRegistration;
	task: ApiTask;
}

const RegistrationHead = ({ registration, task }: RegistrationHeadProps) => {
	const { t } = useTranslation(["registrations", "buttons"]);
	const auth = useAuth();
	const { modules } = auth.company;
	const { user } = registration || {};
	const backUrl = useBackUrl();
	const color = user?.primary_color || "#1aaa9d";
	const textColor = generateTextColor(color);

	return (
		<div className="rounded-md overflow-hidden">
			<div
				style={{
					backgroundColor: color,
				}}
				className="p-12 relative z-[10]"
			>
				<div
					style={{
						color: textColor,
					}}
					className="absolute top-6 right-6 flex items-center gap-4"
				>
					<Link
						to={`/tasks/${task.hid}/show/${registration.hid}/report`}
						className={"font-bold flex items-center gap-2 cursor-pointer transition-all"}
					>
						<i className={"fas fa-flag"}></i>
						<span className="hidden sm:block"> {t("report", { ns: "buttons" })}</span>
					</Link>
					<ConnectUserButton
						user={user as any}
						isConnected={registration.is_connected}
						color="white"
					/>
					<Link
						className="underline"
						target="_blank"
						to={`/view-profile/${user?.hid}?${backUrl}`}
					>
						<strong className="mr-2">{t("full-cv", {ns: "registrations", keyPrefix: "registration-head"})}</strong>
						<i className="fas fa-external-link"></i>
					</Link>
				</div>
			</div>
			<div className="flex z-[20] sm:flex-row flex-col relative gap-4 -mt-12 px-6 sm:items-end rounded-md">
				<Avatar size="xlarge" src={user?.avatar} />
				<div className="flex flex-row flex-wrap justify-between flex-1 gap-2">
					<div className="flex flex-col gap-2">
						<div className="flex justify-between items-center">
							<h2>{user?.full_name}</h2>
							{/* {Number(user?.review || 0) > 0 && isTablet && (
								<Stars
									size={null}
									className="sm:text-[24px]"
									rating={Number(user?.review || 0)}
								/>
							)} */}
						</div>
						<p className="opacity-80">{user.tagline}</p>
					</div>
					<div className="flex flex-col justify-end gap-2">
						{user && (modules || []).includes("student-pool") && (
							<ConnectUserButton
								isConnected={registration.is_connected}
								{...{ user }}
							/>
						)}
						{Number(user?.review || 0) > 0 && (
							<Stars
								size={null}
								className="sm:text-[24px]"
								rating={Number(user?.review || 0)}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegistrationHead;
